import { baseClient } from '@/api/client'

export async function getFeaturesStatus() {
    return baseClient.get(`/user/settings/features/status`)
}

export async function toggleFeatureStatus(feature: string) {
    return baseClient.post(`/user/settings/features/toggle`, {
        feature: feature,
    })
}

export async function saveDescriptionForAiThemes(description: string) {
    return baseClient.post(`/ajax/company/save-description`, {
        company_description: description,
    })
}
